import { config } from "config";

import { SettingsRoutes } from "../constants";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { DefaultIntegration, IntegrationsTab } from "./constants";

export const buildAuthorizedUrl = (
  path = "/",
  redirectUri: string,
  clientId: string,
  responseType = "code"
): string => {
  const accountsUrl = config.globalAccounts;
  return `${accountsUrl}${path}?redirect_uri=${redirectUri}&response_type=${responseType}&client_id=${clientId}`;
};

export const openPopup = (url: string, winName?: string, w?: number, h?: number, scroll?: boolean): Window | null => {
  // @ts-expect-error TS(2532): Object is possibly 'undefined'.
  const LeftPosition = window.screen.width ? (window.screen.width - w) / 2 : 0;
  // @ts-expect-error TS(2532): Object is possibly 'undefined'.
  const TopPosition = window.screen.height ? (window.screen.height - h) / 2 : 0;
  const settings = `height=${h},width=${w},top=${TopPosition},left=${LeftPosition},scrollbars=${scroll},resizable`;

  return window.open(url, winName, settings);
};

export const handleDirectInstallationUrlFlow = ({
  name,
  directInstallUrl,
  clientId,
}: {
  name: string;
  directInstallUrl: string;
  clientId: string;
}): void => {
  const flow = "code";
  const authorizedUrl = buildAuthorizedUrl("/", directInstallUrl, clientId, flow);

  openPopup(authorizedUrl, name, 500, 700, true);
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const isDefaultIntegration = (id: string) => {
  const defaultIntegrations = Object.values(DefaultIntegration);
  return !!defaultIntegrations.find(integrationId => integrationId === id);
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const getProperListUrlForApp = (isPrivateApp: boolean, isInReviewApp: boolean) => {
  let listUrl: string = SettingsRoutes.Integrations;

  if (isPrivateApp) {
    listUrl += `/${IntegrationsTab.private}`;
  } else if (isInReviewApp) {
    listUrl += `/${IntegrationsTab.inReview}`;
  }

  return listUrl;
};
